import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserService } from '../services/user.service';
import * as moment from 'moment-timezone';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthService {
  private expTimer: any = null;
  private modal: any = null;

  constructor(
    private router: Router,
    private permissionsService: NgxPermissionsService,
    private userService: UserService,
    private ngxSmartModalService: NgxSmartModalService,
    protected http: HttpClient
  ) {}

  public getLogo(): Observable<any> {
    return this.http.get('/site/logo-min');
  }

  public authenticate(result) {
    if (result.token) {
      this.setToken(result.token);
      this.setUserId(result.id);
      this.setUsername(result.username);
      this.setServerTimeZone(result.timezone);
      this.setCompanyName(result.companyData.name);
      this.setCompanyId(result.companyData.companyId);
      this.setCompanyLogo(result.companyData.logo);
      this.setAutomatic(result.automatic);
      this.setWorkspaceMasterCustomerID(result.oesCustomerId);
      this.setTokenDtExp(result.exp);
      this.setPermissions(result.permissions);
      this.setTableSettings(result.table_settings);
      this.loadPermissions();
      this.initExpDetection();
    }
  }

  setToken(token) {
    localStorage.setItem('token', token);
  }

  get token() {
    return localStorage.getItem('token');
  }

  setTokenDtExp(dtExp) {
    localStorage.setItem('tokenExp', dtExp);
  }

  get tokenExp() {
    return localStorage.getItem('tokenExp');
  }

  setServerTimeZone(serverTimeZone) {
    localStorage.setItem('serverTimeZone', serverTimeZone);
  }

  get serverTimeZone() {
    return localStorage.getItem('serverTimeZone');
  }

  setAutomatic(automatic) {
    localStorage.setItem('automatic', automatic);
  }

  get automatic(): boolean {
    return localStorage.getItem('automatic').toString() === '1';
  }

  setPermissions(permissions) {
    localStorage.setItem('permissions', permissions);
  }

  get permissions() {
    return localStorage.getItem('permissions');
  }

  setTableSettings(tableSettings) {
    localStorage.setItem('table_settings', tableSettings);
  }

  get tableSettings(): object {
    return JSON.parse(localStorage.getItem('table_settings'));
  }

  setUsername(username) {
    localStorage.setItem('username', username);
  }

  get username() {
    return localStorage.getItem('username');
  }

  setUserId(userid) {
    localStorage.setItem('userid', userid);
  }

  setCompanyName(name) {
    localStorage.setItem('companyName', name);
  }

  get companyName() {
    return localStorage.getItem('companyName');
  }

  setCompanyId(companyId) {
    localStorage.setItem('companyId', companyId);
  }

  get companyId() {
    return localStorage.getItem('companyId');
  }

  setCompanyLogo(logo) {
    localStorage.setItem('companyLogo', logo);
  }

  get companyLogo() {
    return localStorage.getItem('companyLogo');
  }

  get userId(): number {
    return JSON.parse(localStorage.getItem('userid'));
  }

  get isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  setWorkspaceMasterCustomerID(masterCustomerID) {
    if (masterCustomerID) {
      localStorage.setItem('workspaceMasterCustomerId', masterCustomerID);
    } else {
      localStorage.removeItem('workspaceMasterCustomerId');
    }
  }

  get workspaceMasterCustomerID() {
    return localStorage.getItem('workspaceMasterCustomerId');
  }

  logout() {
    clearInterval(this.expTimer);
    this.expTimer = null;
    localStorage.clear();
    this.router.navigate(['signup']);
  }

  loadPermissions() {
    this.permissionsService.flushPermissions();
    this.permissionsService.loadPermissions(this.permissions.split(','));
  }

  notifyUser(seconds) {
    const browserTime = moment(new Date());
    browserTime.add(seconds, 'seconds');

    if (!this.modal) {
      this.modal = this.ngxSmartModalService.getModal('auth');
      this.modal.onOpen.subscribe(() => {
        window.scrollTo(0, 0);
      });
      const me = this;
      this.modal.onCloseFinished.subscribe(() => {
        me.userService.refreshToken(this.token).subscribe((result) => {
          me.authenticate(result);
        });
      });
    }

    this.modal.open();
    this.ngxSmartModalService.setModalData(
      {
        time: browserTime.format('HH:mm:ss A'),
        seconds: Number(seconds),
      },
      'auth',
      true
    );
  }

  initExpDetection() {
    const me = this;
    clearInterval(this.expTimer);
    this.expTimer = null;

    this.expTimer = setInterval(() => {
      const expTime = moment.tz(me.tokenExp, me.serverTimeZone);
      const localTime = moment(new Date()).tz(me.serverTimeZone);
      if (localTime > expTime) {
        me.logout();
      } else {
        const seconds = moment.duration(expTime.diff(localTime)).asSeconds();
        if (seconds <= environment.secondsTokenExpire) {
          me.notifyUser(seconds);
        }
      }
    }, 1000 * 5);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/auth/auth.service.ts